"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultActions = void 0;
var screenfull_1 = __importDefault(require("screenfull"));
var use_player_prefs_1 = require("../hooks/use-player-prefs");
exports.defaultActions = {
    setPlaybackRate: function (context, event) {
        // These threw type errors if the event type wasn't specified
        // assuming that the machine under the hood doesn't
        // have enough context since these actions are very separated
        // from the config.
        if (context.videoRef && event.type === 'PLAYBACKRATE_CHANGE') {
            context.videoRef.current.playbackRate = event.playbackRate;
            (0, use_player_prefs_1.savePlayerPrefs)({
                playbackRate: event.playbackRate,
            });
        }
    },
    setVolume: function (context, event) {
        var _a;
        if (context.videoRef && event.type === 'VOLUME_CHANGE')
            context.videoRef.current.volume = (_a = event.volume) !== null && _a !== void 0 ? _a : 0.8;
    },
    toggleMute: function (context, _event) {
        if (context.videoRef)
            context.videoRef.current.muted = !context.videoRef.current.muted;
    },
    playVideo: function (context, _event) {
        var _a;
        var videoRef = context.videoRef;
        // play() returns a promise https://goo.gl/LdLk22
        var playPromise = (_a = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _a === void 0 ? void 0 : _a.play();
        if (playPromise !== undefined) {
            playPromise
                .then(function () {
                var _a;
                return (_a = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _a === void 0 ? void 0 : _a.play();
            })
                .catch(function (e) { return console.log("PLAY failed: ".concat(e)); });
        }
    },
    pauseVideo: function (context, _event) {
        var _a;
        var videoRef = context.videoRef;
        (_a = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _a === void 0 ? void 0 : _a.pause();
    },
    seekVideo: function (context, _event) {
        var videoRef = context.videoRef, seekingTime = context.seekingTime;
        if (videoRef) {
            videoRef.current.currentTime =
                seekingTime !== null && seekingTime !== void 0 ? seekingTime : videoRef.current.currentTime;
        }
    },
    toggleFullscreen: function (_context, event) {
        if (screenfull_1.default.isEnabled && event.type === 'TOGGLE_FULLSCREEN') {
            var element = event.element === null ? undefined : event.element;
            screenfull_1.default.toggle(element);
        }
    },
    exitFullscreen: function (_context, event) {
        if (screenfull_1.default.isEnabled && event.type === 'EXIT_FULLSCREEN') {
            screenfull_1.default.exit();
        }
    },
    onVideoEnded: function (_context, _event) { },
    saveSubtitlePreference: function (_context, event) {
        var track = event.track;
        var id = track.id, kind = track.kind, label = track.label, language = track.language;
        (0, use_player_prefs_1.savePlayerPrefs)({
            subtitle: {
                id: id,
                kind: kind,
                label: label,
                language: language,
            },
        });
    },
};
